import { render, staticRenderFns } from "./ModalKasKecilReason.vue?vue&type=template&id=340b1701&"
import script from "./ModalKasKecilReason.vue?vue&type=script&lang=js&"
export * from "./ModalKasKecilReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports